import React, { FC } from 'react';
import AcceptanceErrorView from './AcceptanceErrorView';

const AcceptanceError: FC = () => {
  return <AcceptanceErrorView />;
};

export default AcceptanceError;
